<!--
 * @Author: ‘巴博尔’ 2164119982@qq.com
 * @Date: 2023-11-07 10:44:46
 * @LastEditors: ‘巴博尔’ 2164119982@qq.com
 * @LastEditTime: 2023-11-27 10:31:19
 * @FilePath: \admin_pc\src\views\store-lesson-card\components\expCardVT.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-form ref="registerRef" :model="createParam" :rules="rules" label-width="150px">
      <el-form-item label="版本:" prop="userPhone">
        <el-select placeholder="请选择版本"  v-model="createParam.storeLessonCardTemplateId" style="width: 270px" @change="changeLessonIdX">
          <el-option v-for="item in [
            { label: 'A', value: 2 },
            { label: 'B', value: 1 },
          ]" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型:" prop="lessonsId">
        <el-select v-model="createParam.lessonsId" placeholder="请选择业务类型"
          style="width: 270px">
          <el-option v-for="item in storeLessons" :key="item.storeLessonId" :label="item.name" :disabled="item.storeLessonId==createParam.lessonsId?false:true"
            :value="item.storeLessonId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="重命名:" prop="name">
        <el-input v-model="createParam.name" style="width: 270px" :min="0" :precision="1"></el-input>
      </el-form-item>
      <!-- <el-form-item label="比例:" prop="optionsUseValue">
        <el-input-number v-model="createParam.valueMoney" style="width: 270px" :min="0" :precision="1"></el-input-number>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleCreate('registerRef')">保存</el-button>
    </div>
    <worker-word ref="workerWord" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<script>
import { qlLessonTemplate } from "@/api/StoreLesson";
import globaldata from "../../../utils/globaldata";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import { updateLessonsName} from "../../../api/StoreLessonCard";

export default {
  // props: {
  //   storeLessons: Array,
  // },
  components: { WorkerWord },
  data() {
    return {
      refreshWord: new Date().getTime(),
      tData: {
        adminWord: ''
      },
      wordType: 0,
      showWordDlg: false,

      storeLessons: [],
      createParam: {
        storeLessonCardTemplateId:'',
        lessonsId:"",
        name:''
      },
      rules: {
        // name: [{ required: true, message: "请输入卡名称", trigger: "blur" }],
        descripe: [
          { required: true, message: "请输入卡描述", trigger: "blur" },
        ],
        storeLessonCardTemplateId: [
          { required: true, message: "请选择业务类型", trigger: "blur" },
        ],
        useType: [
          { required: true, message: "请选择使用类型", trigger: "blur" },
        ],
        optionsValue: [
          { required: true, message: "请选择计费类型", trigger: "blur" },
        ],
        totalClassCount: [
          { required: true, message: "请输入正价课时", trigger: "blur" },
        ],
        valueMoney: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入兑换名称", trigger: "blur" },
        ],
        lessonsId: [
          { required: true, message: "请选择业务类型", trigger: "change" },
        ],
        validDays: [
          { required: true, message: "请选择卡有效时长", trigger: "blur" },
        ],
      },
    };
  },

  mounted() { },

  methods: {
    handleWord(wordType, tData) {
      let param = {
        ...this.createParam,
        storeFontId: globaldata.getAdminStore().storeFrontId,
        word:tData.adminWord
      }
      updateLessonsName(param).then((res)=>{
            if(res.code == 20000){
              this.$emit("onBtnCreate");
            }
      })
      console.log(param, '===============')
    },
    changeLessonIdX(e) {
      // console.log(e,'===============')
      // return
      this.createParam.lessonsId = ''
      qlLessonTemplate({
        lessonId: e,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessons = res.data
          this.storeLessons.forEach((item,index)=>{
            let idn = index+1
            if( idn< 10){
              item.name ='0'+idn +' - '+item.name
            }else{
              item.name = idn +' - '+item.name

            }
          })
          this.createParam.lessonsId = this.storeLessons[0].storeLessonId
        }
      })
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleCreate(registerRef) {
      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          this.$refs['workerWord'].showDlog = true
          //   let param = this.createParam;
          //   param.storeFrontId = globaldata.getAdminStore().storeFrontId;
          //   param.createAdminId = globaldata.getAdminStore().id;
          //   createUserChild(param).then((response) => {
          //     messageUtils.successMsg(this, "创建成功");
          //     this.$emit("onBtnCreate");
          //   });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/store-lesson-card/components/hostCardVT.vue